

angular
.module('inkfinder')
.factory('StatsFactory', function StatsFactory(
  $rootScope,
  ScheduleUtilFactory,
  moment,
  _
) {
  StatsFactory.resetDataStats = resetDataStats;
  StatsFactory.resetIntervals = resetIntervals;
  StatsFactory.resetIntervalTimes = resetIntervalTimes;
  StatsFactory.recalculateStats = recalculateStats;

  resetVariables();

  /**
   * @name resetVariables
   */
  function resetVariables() {
    StatsFactory.artistStats = {};
    StatsFactory.periods = {};
    StatsFactory.periodRange = {};
    StatsFactory.currentPeriod = {};
    StatsFactory.appointments = [];
    StatsFactory.goals = [];
    StatsFactory.schedules = [];
    StatsFactory.shopHours = [];
  }

  // Called to Reset Data on Logout
  let deregister = $rootScope.$on('clear-data', function() {
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
   * @name resetDataStats
   */
  function resetDataStats() {
    for (let periodKey in StatsFactory.periods) {
      if (Object.prototype.hasOwnProperty.call(StatsFactory.periods, periodKey)) {
        let period = StatsFactory.periods[periodKey];
        period.data = {
          appointments: [],
          hours: [],
          goals: []};
        period.stats = {
          estimates: {goal_percent: 0},
          revenue: {goal_percent: 0}};
        period.change = {};
      }
    }
  }

  /**
   * @name resetIntervals
   * @param {unknown} timePeriod Unknown
   * @param {unknown} number Unknown
   */
  function resetIntervals(timePeriod, number) {
    let periods = StatsFactory.periods = {};

    for (let i = 0; i < 2; i++) {
      let dates = getDateInterval(timePeriod, number + i);
      let dateKey = dates.start.format('MM/DD/YYYY') + '-' + dates.end.format('MM/DD/YYYY');
      let prevDates = getDateInterval(timePeriod, number + i + 1);
      let prevDateKey = prevDates.start.format('MM/DD/YYYY') + '-' + prevDates.end.format('MM/DD/YYYY');
      let period = {calendarInterval: dates, relativeToCurrent: i, prev: prevDateKey};
      periods[dateKey] = period;
    }
  }

  /**
   * @name resetIntervalTimes
   */
  function resetIntervalTimes() {
    let periodRange = StatsFactory.periodRange = {};
    let periods = StatsFactory.periods;

    for (let periodKey in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKey)) {
        let period = periods[periodKey];
        let shopTimes = ScheduleUtilFactory.getShopTimes(
          StatsFactory.shopHours,
          period.calendarInterval.start,
          period.calendarInterval.end
        );
        period.interval = {
          start: shopTimes.earliest.start,
          end: shopTimes.latest.end
        };
        if (!periodRange.end || period.interval.end > periodRange.end) {
          periodRange.end = period.interval.end;
        }
        if (!periodRange.start || period.interval.start < periodRange.start) {
          periodRange.start = period.interval.start;
        }
      }
    }
  }

  /**
   * @name getDateInterval
   * @param {unknown} period Unknown
   * @param {unknown} number Unknown
   * @return {unknown} Unknown
   */
  function getDateInterval(period, number) {
    let firstDay = moment().startOf(period);

    if (number) {
      firstDay.subtract(number, period);
    }
    let lastDay = moment(firstDay).endOf(period);

    return {start: firstDay, end: lastDay};
  }

  /**
   * @name updateShopStats
   * @param {unknown} period Unknown
   */
  function updateShopStats(period) {
    let stats = period.stats = {};
    let data = period.data;
    let appointments = data.appointments;
    let hours = data.hours;
    let goals = data.goals;
    let artists = [];

    let revenueTotal;
    let estimates;
    let projectTotal;
    let scheduleSum;
    let appointmentDurationSum;
    let revenueGoal;
    revenueTotal = estimates = projectTotal = scheduleSum =
    appointmentDurationSum = revenueGoal = 0;
    for (let i = 0; i < appointments.length; i++) {
      let current = appointments[i];
      let status = current.last_status;

      if (status) {
        status = status.status_name;
      }

      if (status === 'Completed') {
        if (current.artist && artists.indexOf(current.artist.id) === -1) {
          artists.push(current.artist.id);
        }

        projectTotal++;
        revenueTotal += current.price;
      }
      if (status === 'Confirmed') {
        estimates += (current.estimate_min + current.estimate_max);
      }
      if (status === 'Completed' || status === 'Confirmed') {
        appointmentDurationSum += current.duration;
      }
    }

    for (let currentPeriod = moment(period.interval.start); currentPeriod <
    period.interval.end; currentPeriod.add(1, 'day')) {
      let endOfDay = moment(currentPeriod).endOf('day');
      let latest;
      for (let a = 0; a < goals.length; a++) {
        let goal = goals[a];
        if (goal.start <= endOfDay && (!goal.end || goal.end >
        currentPeriod) && (!latest || latest.start < goal.start)) {
          latest = goal;
        }
      }

      if (latest) {
        revenueGoal += (latest.weekly_revenue_goal / 7);
      }
    }

    for (let b = 0; b < hours.length; b++) {
      scheduleSum += hours[b].duration;
    }

    stats.goals = {revenue: revenueGoal};
    stats.appointments = projectTotal;
    stats.revenue = {
      total: revenueTotal,
      goal_percent: (revenueGoal ? revenueTotal /
      revenueGoal : (revenueTotal ? 1 : 0))};
    stats.estimates = {
      total: estimates / 2,
      goal_percent: (revenueGoal ? estimates /
      (2 * revenueGoal) : (estimates ? 1 : 0))};
    stats.artists = {
      total: artists.length,
      average_revenue: (artists.length ? revenueTotal / artists.length : 0)};
    stats.utilization = (scheduleSum ? appointmentDurationSum /
    scheduleSum : (appointmentDurationSum ? 1 : 0));
  }

  StatsFactory.updateArtistStats = function(period) {
    let stats = period.stats;
    let data = period.data;

    let appointments = data.appointments;
    let hours = data.hours;

    let revenueTotal = 0;
    let tipTotal = 0;
    let projectTotal = 0;
    let scheduleSum = 0;
    let appointmentDurationSum = 0;
    for (let i = 0; i < appointments.length; i++) {
      let current = appointments[i];
      let status = current.last_status;
      if (status) {
        status = status.status_name;
      }
      if (status === 'Completed') {
        projectTotal++;
        revenueTotal += current.price;
        current.paymentData.tipTotal ? tipTotal
        += current.paymentData.tipTotal : tipTotal + 0;
      }
      if (status === 'Completed' || status === 'Confirmed') {
        appointmentDurationSum += current.duration;
      }
    }

    for (let c = 0; c < hours.length; c++) {
      scheduleSum += hours[c].duration;
    }

    stats.appointments = projectTotal;
    stats.revenue = revenueTotal;
    stats.tips = tipTotal;
    stats.average = (projectTotal ? revenueTotal / projectTotal : 0);
    stats.utilization = (scheduleSum ? appointmentDurationSum /
    scheduleSum : (appointmentDurationSum ? 1 : 0));
  };

  StatsFactory.getArtistStats = function(id) {
    let artist = StatsFactory.artistStats[id];
    if (!artist) {
      artist = prepareArtist({});
      StatsFactory.artistStats[id] = artist;
    }
    return artist;
  };

  /**
   * @name prepareArtist
   * @param {unknown} artist Unknown
   * @return {unknown} Unknown
   */
  function prepareArtist(artist) {
    let periods = StatsFactory.periods;
    artist.periods = {};
    for (let periodKey in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKey)) {
        let period = periods[periodKey];
        let newPeriod = {
          prev: period.prev,
          data: {appointments: [], hours: []},
          stats: {
            appointments: 0,
            revenue: 0,
            tips: 0,
            average: 0,
            utilization: 0},
          change: {},
          relativeToCurrent: period.relativeToCurrent
        };
        artist.periods[periodKey] = newPeriod;
        if (period.relativeToCurrent === 0) {
          artist.current = newPeriod;
        }
      }
    }
    return artist;
  }

  /**
   * @name recalculateStats
   */
  function recalculateStats() {
    let appointments = StatsFactory.appointments;
    let goals = StatsFactory.goals;
    let artistHours = StatsFactory.schedules;
    let periods = StatsFactory.periods;
    _.each(StatsFactory.artistStats, function(artist) {
      prepareArtist(artist);
    });

    for (let periodKey in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKey)) {
        let period = periods[periodKey];
        for (let i = 0; i < appointments.length; i++) {
          let appointment = appointments[i];
          if (appointment.date >= period.interval.start &&
          appointment.date <= period.interval.end) {
            period.data.appointments.push(appointment);
            if (appointment.artist) {
              let artistValues =
              StatsFactory.getArtistStats(appointment.artist.id);
              if (artistValues) {
                artistValues.periods[periodKey].data.appointments
                .push(appointment);
              }
            }
          }
        }
        for (let d = 0; d < goals.length; d++) {
          let goal = goals[d];
          if (goal.start < period.interval.end &&
          (!goal.end || goal.end > period.interval.start)) {
            period.data.goals.push(goal);
          }
        }

        for (let e = 0; e < artistHours.length; e++) {
          let schedule = artistHours[e];
          if (period.interval.start <= schedule.start &&
          schedule.start < period.interval.end) {
            period.data.hours.push(schedule);
            let artistHoursValues =
            StatsFactory.getArtistStats(schedule.rule.artist);
            if (artistHoursValues) {
              artistHoursValues.periods[periodKey].data.hours.push(schedule);
            }
          }
        }
      }
    }

    //  Calculate shop stats
    for (let periodKeyStats in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKeyStats)) {
        let periodStats = periods[periodKeyStats];
        updateShopStats(periodStats);
        if (periodStats.relativeToCurrent === 0) {
          StatsFactory.currentPeriod = periodStats;
        }
      }
    }

    //  Calculate changes
    for (let periodKeyCalc in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKeyCalc)) {
        let current = periods[periodKeyCalc];
        let previous = periods[current.prev];
        if (previous) {
          let text;
          let diff;
          let change = current.change = {};

          diff = Math.round(100 * (current.stats.revenue.goal_percent -
          previous.stats.revenue.goal_percent));
          if (diff > 0) {
            text = 'more than the ' +
            Math.round(100 * previous.stats.revenue.goal_percent) +
            '% you earned of';
          } else if (diff < 0) {
            text = 'less than the ' +
            Math.round(100 * previous.stats.revenue.goal_percent) +
            '% you earned of';
          } else {
            text = 'on par with';
          }
          change.revenue = {
            text: text,
            value: diff};

          diff = current.stats.appointments - previous.stats.appointments;
          if (diff > 0) {
            text = Math.abs(diff) + ' more project' +
            (diff === 1 ? '' : 's') + ' than';
          } else if (diff < 0) {
            text = (diff === -1 ? '1 less project' : Math.abs(diff) +
            ' fewer projects') + ' than';
          } else {
            text = 'the same number of projects as';
          }
          change.appointments = {
            text: text,
            value: diff};

          diff = Math.round(current.stats.artists.average_revenue -
          previous.stats.artists.average_revenue);
          if (diff > 0) {
            text = '$' + Math.abs(diff) + ' more than';
          } else if (diff < 0) {
            text = '$' + Math.abs(diff) + ' less than';
          } else {
            text = 'the same as';
          }
          change.artist_revenue = {
            text: text,
            value: diff};

          diff = Math.round(100 * (current.stats.utilization -
          previous.stats.utilization));
          if (diff > 0) {
            text = Math.abs(diff) + '% more than';
          } else if (diff < 0) {
            text = Math.abs(diff) + '% less than';
          } else {
            text = 'the same as';
          }
          change.utilization = {
            text: text,
            value: diff};
        }
      }
    }

    _.each(StatsFactory.artistStats, function(artistStat) {
      for (let periodKeyUpdate in artistStat.periods) {
        if (Object.prototype.hasOwnProperty.call(artistStat.periods, periodKeyUpdate)) {
          StatsFactory.updateArtistStats(artistStat.periods[periodKeyUpdate]);
        }
      }
      for (let periodKey in artistStat.periods) {
        if (Object.prototype.hasOwnProperty.call(artistStat.periods, periodKey)) {
          let current = artistStat.periods[periodKey];
          let previous = artistStat.periods[current.prev];
          if (previous) {
            current.change = {
              appointments: {
                value: current.stats.appointments - previous.stats.appointments
              },
              revenue: {value: current.stats.revenue - previous.stats.revenue},
              tips: {value: current.stats.tips - previous.stats.tips},
              average: {value: current.stats.average - previous.stats.average},
              utilization: {
                value: current.stats.utilization - previous.stats.utilization
              }
            };
          }
        }
      }
    });
  }
  return StatsFactory;
});



// WEBPACK FOOTER //
// ./components/stats/stats.service.js